<script lang="ts" setup>
import BillingProBadge from '@/core/billing/BillingProBadge.vue';
import InfoTooltip from '@/core/elements/InfoTooltip.vue';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    imageSrc: string;
    label: string;
    isSelected: boolean;
    showInfoButton?: boolean;
    infoText?: string;
    isLocked?: boolean;
  }>(),
  {
    showInfoButton: false,
    infoText: '',
    isLocked: false,
  },
);

const containerClasses = computed(() =>
  [
    'rounded-sm box-border outline outline-2 transition-colors',
    props.isSelected ? 'outline-tint' : 'outline-transparent hover:outline-tint',
  ].join(' '),
);
</script>

<template>
  <div class="flex flex-col items-center justify-center cursor-pointer" tabindex="0" role="button">
    <div :class="containerClasses">
      <img :src="imageSrc" class="block rounded-sm" />
    </div>
    <div class="mt-sm flex items-center gap-xs">
      <span class="text-footer">{{ label }}</span>
      <BillingProBadge v-if="isLocked" class="mx-xs" theme="tint" />
      <InfoTooltip v-if="showInfoButton" :tooltip-text="infoText" content-style="w-[280px]" />
    </div>
  </div>
</template>
